<template>
  <div>
    <div slot="title">      
    </div>
    <div slot="main">
      <div class="container-fluid">
        <div class="row">               
          <div class="col-6">  
            <label >  
              <i 
                class="fas fa-upload"            
                for="inputSubirFirma"
                style="cursor:pointer;"
              ></i>
              <input
                @change="SubirFirma"
                type="file"       
                id="inputSubirFirma"       
                name="subirFirma"
                accept="image/png, image/jpeg, image/jpg, image/tiff"
                hidden
              />
            </label>          
          </div>
          <div v-if="this.ImagenFirmaAutografaBase64 != null" class="col-6 btn-descarga">
            <a                          
              :download="this.personaId + '.jpg'"
              :href="'data:image/jpg;base64,' + this.ImagenFirmaAutografaBase64"
              :disabled="this.ImagenFirmaAutografaBase64 == null"
            >
              <i 
              class="fas fa-download"              
              ></i>
              <!-- v-on:click="DescargarFirma" -->
            </a>
          </div>
        </div>        
      </div>
    </div>
  </div>
</template>

<script>
import catalogos from "@/../static/js/catalogos";
import comun from "@/../static/js/comun";
import enumeraciones from "@/../static/js/enumeraciones";
import api from "@/../static/js/api";
import axios from "axios";
import Vue from "vue";
import store from "@/store/index";

export default {
  props:[
    "personaId",
    "propImagenFirmaAutografaBase64"
  ],
  data() {
    return {
      enumeraciones,
      ImagenFirmaAutografaBase64:null
    };
  },
  components: {
  },
  mounted() {
        if(this.propImagenFirmaAutografaBase64 != null){
          this.ImagenFirmaAutografaBase64 = this.propImagenFirmaAutografaBase64;
        }
    },
  methods: {  
    DescargarFirma(){
      comun.SeEstaCargandoInformacion(true);
      let peticion = {
        PersonaId:this.personaId  
      };
      axios
        .post(
          api.conexion + api.SIAP.funcion.GetImagenFirmaAutografaBase64,
          peticion,
          comun.CrearElHeaderDeAutorizacion(
            this.$store.state.Login_AutorizacionOriginal
          )
        )
        .then(response => {
          if (response.data.SiHayError == false) {
            //Pasa la información de la respuesta al modelo que usa el componente
            this.ImagenFirmaAutografaBase64 = response.data.ImagenFirmaAutografaBase64;
          } else {
            console.log(response);
            comun.mensajeDeAlerta(response.data.Error.Mensaje, null, null);
          }
          comun.SeEstaCargandoInformacion(false);
        })
        .catch(e => {
          console.error(e);
          comun.mensajeDeAlerta(
            comun.mensajeDeError(enumeraciones.error.E500),
            null,
            null
          );
          comun.SeEstaCargandoInformacion(false);
        });
    },
    SubirFirma(event) {
      comun.SeEstaCargandoInformacion(true);

      // Se carga la imagen al formulario.
      var datosDelFormulario = new FormData();
      datosDelFormulario.set("PersonaId", this.personaId);
      datosDelFormulario.append("image", event.target.files[0]);

      // Elimina la foto para evitar usandola
      this.imagenDelRostroBase64 = null;

      axios
        .post(
          api.conexion + api.SIAP.funcion.GuardarFirmaAutografa,
          datosDelFormulario,
          comun.CrearElHeaderDeAutorizacion(
            this.$store.state.Login_AutorizacionOriginal,
            true
          )
        )
        .then(respuesta => {
          console.log(respuesta);
          if (respuesta.data.SiHayError) {
            comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
          } else {
            comun.mensajeDeAlerta(respuesta.data.Satisfactorio, null, null);            
            this.ImagenFirmaAutografaBase64 = respuesta.data.ImagenFirmaAutografaBase64;
          }
          comun.SeEstaCargandoInformacion(false);
        })
        .catch(excepcion => {          
          comun.mensajeDeAlerta(
            comun.mensajeDeError(enumeraciones.error.E500),
            null,
            null
          );
          comun.SeEstaCargandoInformacion(false);
        });
    }
  },
};
</script>

<style scoped>
/* Se requiere para que el color del texto de la tabla sea negro */
table {
  color: #343a40 !important;
}
div.btn-descarga a{
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/SIAP/FirmaAutografa/FirmaAutografa.vue